module.exports = {"amount":"amount","currency":"currency","length":"length","mass":"mass","temperature":"temperature","time":"time","volume":"volume"}